import { React, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faL
} from '@fortawesome/free-solid-svg-icons';
import { Collapse, Image } from 'react-bootstrap';
import { NavLink, useLocation } from 'react-router-dom';
import { useRouteAccessList, useSprintProjectCount } from '@hooks';
import { IoIosArrowDropleftCircle } from 'react-icons/io';
import DashboardIcon from '../../../../assets/images/dashboard/dashboard-icon.svg';
import ProjectsIcon from '../../../../assets/images/dashboard/projects-icon.svg';
import UserIcon from '../../../../assets/images/dashboard/user-icon.svg';
import HrmsIcon from '../../../../assets/images/dashboard/hrms-icon.svg';
import RecruitmentIcon from '../../../../assets/images/dashboard/recruitment-icon.svg';
import MasterIcon from '../../../../assets/images/dashboard/master-icon.svg';
import SettingIcon from '../../../../assets/images/dashboard/setting-icon.svg';
import ReportIcon from '../../../../assets/images/dashboard/report-icon.svg';

const Sidebar = (props) => {
  const { t } = props;
  const [data, setData] = useState([]);
  const [setting, setSetting] = useState(false);
  const [master, setMaster] = useState(false);
  const [user, userMaster] = useState(false);
  const [project, setProject] = useState(false);
  const [hrms, setHRMS] = useState(false);
  const [recruitment, setRecruitment] = useState(false);
  const [reports, setReports] = useState(false);

  const location = useLocation();
  useRouteAccessList((res) => {
    setData(res.data.route_key);
  });
  const shouldShowRoute = (route) => {
    if (data) {
      return data.includes(route);
    }
  };
  // Sub Module States
  // Projects
  const [projectLink, setProjectLink] = useState(false);
  const [dbFieldLink, setDBFieldLink] = useState(false);
  const [myAllTasksLink, setMyAllTasksLink] = useState(false);
  const [allActivitiesLink, setAllActivitiesLink] = useState(false);
  const [allSprintLink, setAllSprintLink] = useState(false);
  // User
  const [userLink, setUserLink] = useState(false);
  const [roleLink, setRoleLInk] = useState(false);
  // HRMS
  const [attendanceLink, setAttendanceLink] = useState(false);
  const [punchInOutLink, setPunchInOutLink] = useState(false);
  const [holidaysETCLink, setHolidaysETCLink] = useState(false);
  const [branchLink, setBranchLink] = useState(false);
  const [departmentLink, setDepartmentLink] = useState(false);
  const [hrScoringParameterLink, setHrScoringParameterLink] = useState(false);
  const [hrScoringLink, setHrScoringLink] = useState(false);
  const [skillScoringParameterLink, setSkillScoringParameterLink] = useState(false);

  // Recruitment
  const [job_position, setJobPosition] = useState(false);



  // Recruitment
  const [recruitment_cities, setRecruitmentCities] = useState(false);
  const [recruitment_interview_status, setRecruitmentInterviewStatus] = useState(false);
  const [recruitment_candidate_companies, setRecruitmentCandidateCompanies] = useState(false);
  const [recruitment_candidate_sources, setRecruitmentCandidateSources] = useState(false);
  const [recruitment_candidate_skills, setRecruitmentCandidateSkills] = useState(false);

  const [reports_public, setReportsPublic] = useState(false);
  const [reports_private, setReportsPrivate] = useState(false);

  // Master
  const [translationsLink, setTranslationLink] = useState(false);
  const [emailTemplateLink, setEmailTemplateLink] = useState(false);
  const [faqCategoryLink, setFAQCategoryLink] = useState(false);
  const [faqsLink, setFAQSLink] = useState(false);
  // Setting
  const [generalLink, setGeneralLink] = useState(false);

  const { data: projectsCountData } = useSprintProjectCount();
  useEffect(() => {
    if (location) {
      // Pathname
      const pathName = location.pathname;
      // Project And DB Field Type
      setProject(
        pathName.includes('/projects') || pathName.includes('/all-sprints')|| pathName.includes('/dbfieldtype') || pathName.includes('/myalltasks') || pathName.includes('/all-activities') ? true : false
      );
      setProjectLink(pathName.includes('/projects') ? true : false);
      setAllSprintLink(pathName.includes('/all-sprints') ? true : false);
      setDBFieldLink(pathName.includes('/dbfieldtype') ? true : false);
      setMyAllTasksLink(pathName.includes('/myalltasks') ? true : false);
      setAllActivitiesLink(pathName.includes('/all-activities') ? true : false);
      // User And Roles
      userMaster(pathName.includes('/user') || pathName.includes('/roles') ? true : false);
      setUserLink(pathName.includes('/user') ? true : false);
      setRoleLInk(pathName.includes('/roles') ? true : false);
      // HRMS
      setHRMS(
        pathName.includes('/attendance') ||
          pathName.includes('/punch-in-out') ||
          pathName.includes('/branch') ||
          pathName.includes('/department/') ||
          pathName.includes('/holidays-etc') ||
          pathName.includes('/hr-scoring-parameters/') ||
          pathName.includes('/hr-scoring/') ||
          pathName.includes('/skill-scoring-parameters/') ||
          pathName.includes('/skills-scoring-options/')
          ? true
          : false
      );

      setRecruitment(
        pathName.includes('/job-position') || pathName.includes('/recruitment-interview-status') ||
          pathName.includes('/recruitment-cities') ||
          pathName.includes('/recruitment-candidate-sources') ||
          pathName.includes('/recruitment-candidate-skills') ||
          pathName.includes('/recruitment-candidate-companies')
          ? true
          : false
      );
      setRecruitmentInterviewStatus(
        pathName.includes('/recruitment-interview-status') ? true : false
      );
      setRecruitmentCities(pathName.includes('/recruitment-cities') ? true : false);
      setRecruitmentCandidateSources(
        pathName.includes('/recruitment-candidate-sources') ? true : false
      );
      setRecruitmentCandidateSkills(
        pathName.includes('/recruitment-candidate-skills') ? true : false
      );
      setRecruitmentCandidateCompanies(
        pathName.includes('/recruitment-candidate-companies') ? true : false
      );

      setAttendanceLink(pathName.includes('/attendance') ? true : false);
      setPunchInOutLink(pathName.includes('/punch-in-out') ? true : false);
      setHolidaysETCLink(pathName.includes('/holidays-etc') ? true : false);

      setBranchLink(pathName.includes('/branch') ? true : false);
      setDepartmentLink(pathName.includes('/department') ? true : false);
      const isHrScoringParameters = /^\/hr-scoring-parameters(\/|$)/.test(pathName);
      const isHrScoring = /^\/hr-scoring(\/|$)/.test(pathName) && !isHrScoringParameters;

      setHrScoringParameterLink(isHrScoringParameters);
      setHrScoringLink(isHrScoring);
      setSkillScoringParameterLink((pathName.includes('/skill-scoring-parameters') || pathName.includes('/skills-scoring-options/')) ? true : false);
      // Master
      setMaster(
        pathName.includes('/translations') ||
          pathName.includes('/email-template') ||
          pathName.includes('/faq-category') ||
          pathName.includes('/faq')
          ? true
          : false
      );
      setTranslationLink(pathName.includes('/translations') ? true : false);
      setEmailTemplateLink(pathName.includes('/email-template') ? true : false);
      setFAQCategoryLink(pathName.includes('/faq-category') ? true : false);
      setFAQSLink(pathName.includes('/faq') && !pathName.includes('/faq-category') ? true : false);
      // Setting
      setSetting(pathName.includes('/general') || pathName.includes('/other') || pathName.includes('/biometric') ? true : false);
      setGeneralLink(pathName.includes('/general') || pathName.includes('/other') || pathName.includes('/biometric') ? true : false);

      // Recruitment
      setJobPosition(pathName.includes('/job-position'));

      setRecruitmentCandidateSkills(
        pathName.includes('/recruitment-candidate-skills') ? true : false
      );
      setRecruitmentCandidateSources(
        pathName.includes('/recruitment-candidate-sources') ? true : false
      );
      setRecruitmentCandidateCompanies(
        pathName.includes('/recruitment-candidate-companies') ? true : false
      );
      setRecruitmentCities(pathName.includes('/recruitment-cities') ? true : false);
      setRecruitmentInterviewStatus(pathName.includes('/recruitment-interview-status') ? true : false);
      setReportsPublic(pathName.includes('/reports/public') ? true : false);
      setReportsPrivate(pathName.includes('/reports/private') ? true : false);
    }
  }, [location]);

  const projectChange = () => {
    setSetting(false);
    setMaster(false);
    userMaster(false);
    setProject(!project);
    setHRMS(false);
    setRecruitment(false);
  };
  const userChange = () => {
    setSetting(false);
    setMaster(false);
    userMaster(!user);
    setProject(false);
    setHRMS(false);
    setRecruitment(false);
  };
  const hrmsChange = () => {
    setSetting(false);
    setMaster(false);
    userMaster(false);
    setProject(false);
    setHRMS(!hrms);
    setRecruitment(false);
  };
  const recruitmentChange = () => {
    setSetting(false);
    setMaster(false);
    userMaster(false);
    setProject(false);
    setHRMS(false);
    setRecruitment(!recruitment);
  };
  const masterChange = () => {
    setSetting(false);
    setMaster(!master);
    userMaster(false);
    setProject(false);
    setHRMS(false);
    setRecruitment(false);
  };
  const settingChange = () => {
    setSetting(!setting);
    setMaster(false);
    userMaster(false);
    setProject(false);
    setHRMS(false);
    setRecruitment(false);
  };

  const reportsChange = () => {
    setReports(!reports);
    setMaster(false);
    userMaster(false);
    setProject(false);
    setHRMS(false);
    setRecruitment(false);
    setSetting(false);
  };
  return (
    <>
      <aside
        id="sidebar-wrapper"
        className={
          props?.active ? `sidebar-main-wrapper sidebar_collapsed` : 'sidebar-main-wrapper'
        }>
        <div className="sidebar">
          <nav className="navigation">
            <div className="dashboard-toggle-btn">
              <IoIosArrowDropleftCircle
                onClick={() => {
                  props.toggleClass();
                }}
              />
            </div>
            <div className="sidebar-div">
              {shouldShowRoute('dashboard') && (
                <ul className="main-submenu" title={t('page.sidebar_dashboard')}>
                  <li>
                    <NavLink to="/dashboard" className="sidebar-menu-wrapper">
                      <span className="sidebar-icon">
                        <Image src={'admin/' + DashboardIcon} />
                      </span>
                      <label>{t('page.sidebar_dashboard')}</label>
                    </NavLink>
                  </li>
                </ul>
              )}
            </div>

            <div className="sidebar-div">
              {shouldShowRoute('projects') || shouldShowRoute('dbfieldtype') || shouldShowRoute('myalltasks') || shouldShowRoute('all-activities') ? (
                <ul className="main-submenu" title={t('page.sidebar_projects')}>
                  <li>
                    <span
                      className={
                        projectLink || dbFieldLink || myAllTasksLink || allActivitiesLink || allSprintLink
                          ? 'active sidebar-menu-wrapper'
                          : 'sidebar-menu-wrapper'
                      }>
                      <NavLink to="/projects/list" className="sidebar-icon">
                        <Image src={'admin/' + ProjectsIcon} />
                      </NavLink>
                      <label onClick={() => projectChange()} aria-expanded={project}>
                        {t('page.sidebar_projects')}
                      </label>
                      <small
                        className="right-side-set-arrow"
                        onClick={() => projectChange()}
                        aria-expanded={project}>
                        <FontAwesomeIcon
                          icon={project ? faChevronDown : faChevronRight}
                          className="dropdown_icon"
                        />
                      </small>
                    </span>
                    <Collapse in={project} className="p-0">
                      <ul className="submenu">
                        {shouldShowRoute('projects') && (
                          <li>
                            <NavLink to="/projects/list" className={projectLink ? 'active' : ''}>
                              {t('page.sidebar_project')}
                            </NavLink>
                          </li>
                        )}
                        {shouldShowRoute('all-sprint') && (
                          <li>
                            <NavLink to="/all-sprints/list" className={allSprintLink ? 'active d-flex align-items-center gap-1' : 'd-flex align-items-center gap-1'}>
                              {t('page.sidebar_all_sprints')}
                              {projectsCountData?.data?.due_projects > 0 && (
                                <span className="status-label red">
                                  {projectsCountData.data.due_projects}
                                </span>
                              )}

                              {projectsCountData?.data?.due_in_seven_days_projects > 0 && (
                                <span className="status-label blue">
                                  {projectsCountData.data.due_in_seven_days_projects}
                                </span>
                              )}

                            </NavLink>
                          </li>
                        )}
                        {shouldShowRoute('dbfieldtype') && (
                          <li>
                            <NavLink to="/dbfieldtype/list" className={dbFieldLink ? 'active' : ''}>
                              {t('page.sidebar_dbfieldtype')}
                            </NavLink>
                          </li>
                        )}
                        {shouldShowRoute('all-activities') && (
                          <li>
                            <NavLink to="/all-activities/list" className={allActivitiesLink ? 'active' : ''}>
                              {t('page.sidebar_all_activities')}
                            </NavLink>
                          </li>
                        )}
                        {shouldShowRoute('myalltasks') && (
                          <li>
                            <NavLink to="/myalltasks/list" className={myAllTasksLink ? 'active' : ''}>
                              {t('page.sidebar_myalltasks')}
                            </NavLink>
                          </li>
                        )}
                      </ul>
                    </Collapse>
                  </li>
                </ul>
              ) : null}

              {shouldShowRoute('role') || shouldShowRoute('user') ? (
                <ul className="main-submenu" title={t('page.sidebar_users')}>
                  <li>
                    <span
                      className={
                        roleLink || userLink
                          ? 'active sidebar-menu-wrapper'
                          : 'sidebar-menu-wrapper'
                      }>
                      <NavLink to="/roles/list" className="sidebar-icon">
                        <Image src={'admin/' + UserIcon} />
                      </NavLink>
                      <label onClick={() => userChange()} aria-expanded={user}>
                        {t('page.sidebar_users')}
                      </label>
                      <small
                        className="right-side-set-arrow"
                        onClick={() => userChange()}
                        aria-expanded={user}>
                        <FontAwesomeIcon
                          icon={user ? faChevronDown : faChevronRight}
                          className="dropdown_icon"
                        />
                      </small>
                    </span>
                    <Collapse in={user} className="p-0">
                      <ul className="submenu">
                        {shouldShowRoute('role') && (
                          <li>
                            <NavLink to="/roles/list" className={roleLink ? 'active' : ''}>
                              {t('page.sidebar_roles')}
                            </NavLink>
                          </li>
                        )}
                        {shouldShowRoute('user') && (
                          <li>
                            <NavLink to="/user/list" className={userLink ? 'active' : ''}>
                              {t('page.sidebar_users')}
                            </NavLink>
                          </li>
                        )}
                      </ul>
                    </Collapse>
                  </li>
                </ul>
              ) : null}
              {shouldShowRoute('attendance') ||
                shouldShowRoute('hr-scoring') ||
                shouldShowRoute('biometric') ||
                shouldShowRoute('branch') ||
                shouldShowRoute('department') ||
                shouldShowRoute('hr-scoring-parameters') ||
                shouldShowRoute('skill-scoring-parameters') ||
                shouldShowRoute('holidays-etc') ? (
                <ul className="main-submenu" title={t('page.sidebar_hrms')}>
                  <li>
                    <span
                      className={
                        (attendanceLink ||
                        punchInOutLink ||
                        holidaysETCLink ||
                        branchLink ||
                        departmentLink ||
                        hrScoringParameterLink ||
                        hrScoringLink ||
                        skillScoringParameterLink)
                          ? 'active sidebar-menu-wrapper'
                          : 'sidebar-menu-wrapper'
                      }>
                      <NavLink to="/attendance/own" className="sidebar-icon">
                        <Image src={'admin/' + HrmsIcon} />
                      </NavLink>
                      <label onClick={() => hrmsChange()} aria-expanded={hrms}>
                        {t('page.sidebar_hrms')}
                      </label>
                      <small
                        className="right-side-set-arrow"
                        onClick={() => hrmsChange()}
                        aria-expanded={hrms}>
                        <FontAwesomeIcon
                          icon={hrms ? faChevronDown : faChevronRight}
                          className="dropdown_icon"
                        />
                      </small>
                    </span>
                    <Collapse in={hrms} className="p-0">
                      <ul className="submenu">
                        {shouldShowRoute('attendance') && (
                          <li>
                            <NavLink to="/attendance/own" className={attendanceLink ? 'active' : ''}>
                              {t('page.sidebar_attendance')}
                            </NavLink>
                          </li>
                        )}
                        {shouldShowRoute('biometric') && (
                          <li>
                            <NavLink
                              to="/punch-in-out/own"
                              className={punchInOutLink ? 'active' : ''}>
                              {t('page.sidebar_punch_in_out')}
                            </NavLink>
                          </li>
                        )}
                        {shouldShowRoute('holidays-etc') && (
                          <li>
                            <NavLink
                              to="/holidays-etc/list"
                              className={holidaysETCLink ? 'active' : ''}>
                              {t('page.sidebar_holidays_etc')}
                            </NavLink>
                          </li>
                        )}
                        {shouldShowRoute('branch') && (
                          <li>
                            <NavLink to="/branch/list" className={branchLink ? 'active' : ''}>
                              {t('page.sidebar_branch')}
                            </NavLink>
                          </li>
                        )}
                        {shouldShowRoute('department') && (
                          <li>
                            <NavLink to="/department/list" className={departmentLink ? 'active' : ''}>
                              {t('page.sidebar_department')}
                            </NavLink>
                          </li>
                        )}
                        {shouldShowRoute('hr-scoring-parameters') && (
                          <li>
                              <NavLink to="/hr-scoring-parameters/list" className={hrScoringParameterLink ? 'active' : ''}>
                                {t('page.sidebar_hr_scoring_parameters')}
                              </NavLink>
                          </li>
                        )}
                        {shouldShowRoute('hr-scoring') && (
                        <li>
                            <NavLink to="/hr-scoring/own/table" className={hrScoringLink ? 'active' : ''}>
                              {t('page.sidebar_hr_scoring')}
                            </NavLink>
                        </li>
                      )}
                        {shouldShowRoute('skill-scoring-parameters') && (
                          <li>
                              <NavLink to="/skill-scoring-parameters/list" className={skillScoringParameterLink ? 'active' : ''}>
                                {t('page.sidebar_skill_scoring_parameter')}
                              </NavLink>
                          </li>
                        )}
                      </ul>
                    </Collapse>
                  </li>
                </ul>
              ) : null}
              {shouldShowRoute('recruitment-interview-status') || shouldShowRoute('recruitment-cities') || shouldShowRoute('recruitment-candidate-sources') || shouldShowRoute('recruitment-candidate-skills') || shouldShowRoute('recruitment-candidate-companies') ? (
                <ul className="main-submenu" title={t('page.sidebar_recruitment')}>
                  <li>
                    <span
                      className={
                        recruitment_interview_status ||
                          recruitment_candidate_skills ||
                          recruitment_candidate_sources ||
                          recruitment_cities ||
                          recruitment_candidate_companies
                          ? 'active sidebar-menu-wrapper'
                          : 'sidebar-menu-wrapper'
                      }>
                      <span className="sidebar-icon">
                        <NavLink to="/recruitment-interview-status/list" className="sidebar-icon">
                          <Image src={'admin' + RecruitmentIcon} />
                        </NavLink>
                      </span>
                      <label onClick={() => recruitmentChange()} aria-expanded={recruitment}>
                        {t('page.sidebar_recruitment')}
                      </label>
                      <small
                        className="right-side-set-arrow"
                        onClick={() => recruitmentChange()}
                        aria-expanded={recruitment}>
                        <FontAwesomeIcon
                          icon={recruitment ? faChevronDown : faChevronRight}
                          className="dropdown_icon"
                        />
                      </small>
                    </span>
                    <Collapse in={recruitment} className="p-0">
                      <ul className="submenu">
                        {shouldShowRoute('Job-position') && (
                          <li>
                            <NavLink to="/job-position/list" className={job_position ? 'active' : ''}>
                              {t('page.sidebar_recruitment_job_opening')}
                            </NavLink>
                          </li>
                        )}
                        {shouldShowRoute('recruitment-interview-status') && (
                          <li>
                            <NavLink to="/recruitment-interview-status/list" className={recruitment_interview_status ? 'active' : ''}>
                              {t('page.sidebar_recruitment_interview_status')}
                            </NavLink>
                          </li>
                        )}
                        {shouldShowRoute('recruitment-candidate-skills') && (
                          <li>
                            <NavLink to="/recruitment-candidate-skills/list" className={recruitment_candidate_skills ? 'active' : ''}>
                              {t('page.sidebar_recruitment_candidate_skills')}
                            </NavLink>
                          </li>
                        )}
                        {shouldShowRoute('recruitment-candidate-sources') && (
                          <li>
                            <NavLink
                              to="/recruitment-candidate-sources/list"
                              className={recruitment_candidate_sources ? 'active' : ''}>
                              {t('page.sidebar_recruitment_candidate_sources')}
                            </NavLink>
                          </li>
                        )}
                        {shouldShowRoute('recruitment-cities') && (
                          <li>
                            <NavLink
                              to="/recruitment-cities/list"
                              className={recruitment_cities ? 'active' : ''}>
                              {t('page.sidebar_recruitment_cities')}
                            </NavLink>
                          </li>
                        )}

                        {shouldShowRoute('recruitment-candidate-companies') && (
                          <li>
                            <NavLink
                              to="/recruitment-candidate-companies/list"
                              className={recruitment_candidate_companies ? 'active' : ''}>
                              {t('page.sidebar_recruitment_candidate_companies')}
                            </NavLink>
                          </li>
                        )}
                      </ul>
                    </Collapse>
                  </li>
                </ul>
              ) : null}

              {shouldShowRoute('reports-public') || shouldShowRoute('reports-private') ? (
                <ul className="main-submenu" title={t('page.sidebar_report')}>
                  <li>
                    <span
                      className={
                        reports_public || reports_private
                          ? 'active sidebar-menu-wrapper'
                          : 'sidebar-menu-wrapper'
                      }>
                      <span className="sidebar-icon">
                        <NavLink to="/reports/public/sign-in-out" className="sidebar-icon">
                          <Image src={'admin' + ReportIcon} />
                        </NavLink>
                      </span>
                      <label onClick={() => reportsChange()} aria-expanded={reports}>
                        {t('page.sidebar_report')}
                      </label>
                      <small
                        className="right-side-set-arrow"
                        onClick={() => reportsChange()}
                        aria-expanded={reports}>
                        <FontAwesomeIcon
                          icon={reports ? faChevronDown : faChevronRight}
                          className="dropdown_icon"
                        />
                      </small>
                    </span>
                    <Collapse in={reports} className="p-0">
                      <ul className="submenu">
                        {shouldShowRoute('reports-public') && (
                          <li>
                            <NavLink
                              to="/reports/public/view"
                              className={reports_public ? 'active' : ''}>
                              {t('page.sidebar_report_public')}
                            </NavLink>
                          </li>
                        )}
                        {shouldShowRoute('reports-private') && (
                          <li>
                            <NavLink
                              to="/reports/private/view"
                              className={reports_private ? 'active' : ''}>
                              {t('page.sidebar_report_private')}
                            </NavLink>
                          </li>
                        )}
                      </ul>
                    </Collapse>
                  </li>
                </ul>
              ) : null}
            </div>

            <div className="sidebar-div">
              {shouldShowRoute('translations') ||
                shouldShowRoute('email-template') ||
                shouldShowRoute('faq-category') ||
                shouldShowRoute('faq') ? (
                <ul className="main-submenu" title={t('page.sidebar_masters')}>
                  <li>
                    <span
                      className={
                        translationsLink || emailTemplateLink || faqCategoryLink || faqsLink
                          ? 'active sidebar-menu-wrapper'
                          : 'sidebar-menu-wrapper'
                      }>
                      <NavLink to="/translations/list" className="sidebar-icon">
                        <Image src={'admin/' + MasterIcon} />
                      </NavLink>
                      <label onClick={() => masterChange()} aria-expanded={master}>
                        {t('page.sidebar_masters')}
                      </label>
                      <small
                        className="right-side-set-arrow"
                        onClick={() => masterChange()}
                        aria-expanded={master}>
                        <FontAwesomeIcon
                          icon={master ? faChevronDown : faChevronRight}
                          className="dropdown_icon"
                        />
                      </small>
                    </span>
                    <Collapse in={master} className="p-0">
                      <ul className="submenu">
                        {shouldShowRoute('translations') && (
                          <li>
                            <NavLink
                              to="/translations/list"
                              className={translationsLink ? 'active' : ''}>
                              {t('page.sidebar_translations')}
                            </NavLink>
                          </li>
                        )}
                        {shouldShowRoute('email-template') && (
                          <li>
                            <NavLink
                              to="/email-template/list"
                              className={emailTemplateLink ? 'active' : ''}>
                              {t('page.sidebar_emailtemplates')}
                            </NavLink>
                          </li>
                        )}
                        {shouldShowRoute('faq-category') && (
                          <li>
                            <NavLink
                              to="/faq-category/list"
                              className={faqCategoryLink ? 'active' : ''}>
                              {t('page.sidebar_faq_category')}
                            </NavLink>
                          </li>
                        )}
                        {shouldShowRoute('faq') && (
                          <li>
                            <NavLink to="/faq/list" className={faqsLink ? 'active' : ''}>
                              {t('page.sidebar_faq')}
                            </NavLink>
                          </li>
                        )}
                      </ul>
                    </Collapse>
                  </li>
                </ul>
              ) : null}
              {shouldShowRoute('setting.general_setting') ||
                shouldShowRoute('setting.biometric_setting') ||
                shouldShowRoute('setting.other_setting') ? (
                <ul className="main-submenu" title={t('page.sidebar_settings')}>
                  <li>
                    <span
                      className={
                        generalLink ? 'active sidebar-menu-wrapper' : 'sidebar-menu-wrapper'
                      }>
                      <NavLink
                        to={
                          shouldShowRoute('setting.general_setting')
                            ? '/setting/general'
                            : shouldShowRoute('setting.biometric_setting')
                            ? '/setting/biometric'
                            : '/setting/other'
                        }
                        className="sidebar-icon">
                        <Image src={'admin/' + SettingIcon} />
                      </NavLink>
                      <label onClick={() => settingChange()} aria-expanded={setting}>
                        {t('page.sidebar_settings')}
                      </label>
                      <small
                        className="right-side-set-arrow"
                        onClick={() => settingChange()}
                        aria-expanded={setting}>
                        <FontAwesomeIcon
                          icon={setting ? faChevronDown : faChevronRight}
                          className="dropdown_icon"
                        />
                      </small>
                    </span>
                    <Collapse in={setting} className="p-0">
                      <ul className="submenu">
                        {(shouldShowRoute('setting.general_setting') ||
                          shouldShowRoute('setting.biometric_setting') ||
                          shouldShowRoute('setting.other_setting')) && (
                          <li>
                            <NavLink
                              to={
                                shouldShowRoute('setting.general_setting')
                                  ? '/setting/general'
                                  : shouldShowRoute('setting.biometric_setting')
                                  ? '/setting/biometric'
                                  : '/setting/other'
                              }
                              className={generalLink ? 'active' : ''}
                            >
                              {t('page.sidebar_generals')}
                            </NavLink>
                          </li>
                        )}
                      </ul>
                    </Collapse>
                  </li>
                </ul>
              ) : null}</div>
          </nav>
        </div>
      </aside>
    </>
  );
};
Sidebar.propTypes = {
  toggleClass: PropTypes.any.isRequired,
  t: PropTypes.func
};
export { Sidebar };
